let map
const latitude = window.localStorage.getItem('latitude')
const longitude = window.localStorage.getItem('longitude')

function initMap() {
  const mapContainer = document.querySelector('#map')
  
  if(mapContainer !== null){
    map = new google.maps.Map(mapContainer, {
      center: {
        lat: latitude ? parseFloat(latitude) : 41.850033,
        lng: longitude ? parseFloat(longitude) : -87.6500523
      },
      zoom: latitude && longitude ? 8 : 3
    })
    
    createMarkers(map)

    document.addEventListener('origin:changed', ev => {
      if (!map) {
        return
      }

      const nextZoom = (ev.detail && ev.detail.zoom) || map.getZoom()
      map.setCenter(ev.detail.latLng)
      map.setZoom(nextZoom)
    })
  }
}

// Draw markers on google map.
const locations = document.querySelectorAll('.locations-list-item')

function createMarkers(map) {
  Array.from(locations).forEach(location => {
    const lat = location.dataset.latitude
    const lng = location.dataset.longitude
    const storeName = location.dataset.locationName
    const storeAddress = location.querySelector('address')
    const storePhoneNumber = location.querySelector('.locations-list-item__tel')
    const storeLink = location.querySelector('.locations-list-item__menu-link').getAttribute('href')

    const storeLatLng = { lat: parseFloat(lat), lng: parseFloat(lng) }

    const contentString = `
        <div>
          <h1>${storeName}</h1>
          <a class="locations-list-item__tel" href="tel:">${storePhoneNumber.innerHTML}</a><br>
          <address style="margin: 1rem 0;">${storeAddress.innerHTML}</address><br>
          <a class="locations-list-item__menu-link" href="${storeLink}">Menu &amp; Location Info >></a>
        </div>
    `

    const infoWindow = new google.maps.InfoWindow({
      content: contentString
    })

    const marker = new google.maps.Marker({
      position: storeLatLng,
      title: storeName
    })

    marker.addListener('click', () => {
      infoWindow.open(map, marker)
    })

    marker.setMap(map)
  })
}

function init() {
    window.initMap = initMap
  }
  
  export default init


// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/global/locationsGoogleMap.js